import React from 'react';
import '../style/agentsList.css'
import '../style/applicationsAndPolicies.css';
import Autosuggest from "react-autosuggest";
import '../style/dots.css';
import {TABLE_VIEW_OPTIONS} from "../helpers/variables";
import CustomTable from "./General/customTable/CustomTable";
import {Link} from "react-router-dom";

const columns = [
    {propertyName: "username", header: "Username", formatter: (row) => (
        <Link to={'/users/edit-user/' + row.id} >{row.username}</Link>
    )},
    {propertyName: "forename", header: "Forename"},
    {propertyName: "surname", header: "Surname"},
    {propertyName: "email", header: "Email"},
    {propertyName: "disabled", header: "Status", formatter: (row) => (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" style={{fill: row.disabled ?'#e0666c':'#94b494'}} width={'12px'}
                 height={'12px'} viewBox="0 0 12 12"><title>Asset 4</title>
                <g id="Layer_2" data-name="Layer 2">
                    <g id="info">
                        <circle className="cls-1" cx="6" cy="6" r="6"/>
                    </g>
                </g>
            </svg>
            &nbsp;
            {
                row.disabled ? 'Inactive':'Active'
            }
        </div>
     )},
];


const UsersList = (props) => {
    const featured = props.calculateFeatured()[0];
    const featuredLength = props.calculateFeatured()[1];
    const totalDisplayBoxes = Math.ceil(featuredLength / parseInt(props.usersList.usersListSettings.displayAmount));

    return (
        <div className="row">
            <div className="col-sm-12 applicationsAndPolicies-wrapper">
                <div className="row">
                    <h2 className="col-sm-12 applicationsAndPolicies-h2">Users</h2>
                </div>
                <form className="form-horizontal applicationsAndPolicies-top-wrapper" onSubmit={evt=>{evt.preventDefault(); props.handleInputChange('selectedSuggestions', props.usersList.usersListSettings.suggestions)}}>

                    <div className="form-group">
                        <div className="col-sm-2">
                            <label className={'control-label.text-left formGroupSelectInput-label'}>
                                {"Search"}
                            </label>
                        </div>
                        <div className="col-sm-7 applicationsAndPolicies-autosuggest-wrapper">
                            <Autosuggest
                                suggestions={props.suggestions}
                                onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={props.onSuggestionsClearRequested}
                                getSuggestionValue={props.getSuggestionValue}
                                renderSuggestion={props.renderSuggestion}
                                inputProps={props.inputProps}
                                onSuggestionSelected={props.onSuggestionSelected}
                                theme ={{
                                    container: 'agents-list-action-autoSuggest-container',
                                    input:'applicationsAndPolicies-autosuggest',
                                    suggestionsContainer: 'applicationsAndPolicies-autosuggest-suggestionsContainer',
                                    suggestionsList: 'applicationsAndPolicies-autosuggest-suggestionsList',
                                    suggestion: 'applicationsAndPolicies-autosuggest-suggestion',
                                    suggestionHighlighted:'applicationsAndPolicies-autosuggest-suggestion-highLighted'
                                }}
                            />
                            <div className="applicationsAndPolicies-autosuggest-search-icon"
                                 onClick={props.handleAutosuggestButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                        <g id="info">
                                            <path
                                                d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </form>
                <div className={'mt-15'}>
                    <CustomTable
                        onSelectedActionApply={props._applyAction}
                        onSelectAction={(evt) => props.handleInputChange(evt.target.name, evt.target.value)}
                        selectedAction={props.usersList.usersListSettings.selectedAction}
                        selectActions={[
                            {key: 'enable', label: 'Enable User(s)'},
                            {key: 'disable', label: 'Disable User(s)'},
                        ]}
                        onSelectAll={props._handleAllRowsSelect}
                        onDatumSelect={(checked, rowIndex, row) => props._handleRowSelect(checked, rowIndex, row)}
                        selected={props.usersList.selectedAragUsers}
                        selectable
                        accordionItemHeaderFormatter={(row) => (
                            `Username: ${row.username} Email: ${row.email}`
                        )}
                        onPageSizeChange={(evt) => {props.handleInputChange('displayAmount',evt.target.value)}}
                        goAtPage={props.handleInputChange}
                        onPageShift={props.usersPagination}
                        loading={props.usersList.fetching}
                        responsive
                        striped
                        columns={columns}
                        data={featured}
                        pageSize={parseInt(props.usersList.usersListSettings.displayAmount)}
                        totalRecords={featuredLength}
                        totalPages={totalDisplayBoxes}
                        page={props.usersList.usersListSettings.page}
                        pageSizeOptions={TABLE_VIEW_OPTIONS}
                    />

                </div>
            </div>
        </div>
    )

};

export default UsersList